import { css } from 'styled-components';
import { TypographyName } from '../../theme/typography';
import { getTypography, rgba } from '../../theme/utils';
const height = 3.125;
export const label = _ref => {
  let {
    theme,
    $isDisabled,
    $isChecked,
    $error
  } = _ref;
  return css(["padding:0 1rem;align-items:center;display:flex;position:relative;cursor:pointer;border-radius:.3rem;background:transparent;height:", "rem;border:1px solid ", ";", " ", " ", " & > input{position:absolute;left:-9999px;margin:0;padding:0;}& > i{content:' ';flex-shrink:0;border:2px solid ", ";border-radius:2px;display:inline-flex;height:1rem;margin-right:.5rem;position:relative;width:1rem;", "}& > input:disabled ~ *{opacity:.4;}& > i:after{border-right:2px solid ", ";border-bottom:2px solid ", ";content:' ';opacity:0;position:absolute;width:.6rem;height:1.2rem;transform:translate(0rem,-.8rem) rotate(45deg);transform-origin:0% 100%;}& > input:checked ~ i{border-color:transparent;}& > input:checked ~ i:after{border-color:", ";}& > input:checked ~ i:after{opacity:1;}"], height, theme.palettes.neutrals.medium, $isDisabled && `
    cursor: not-allowed;
    border-color: ${theme.palettes.neutrals.light};
  `, $error && `
    border-color: ${theme.palettes.status.alert};
  `, $isChecked && `
    border-color: ${theme.palettes.brand.primary};
    color: ${theme.palettes.brand.primary};
    box-shadow: 0 0 10px 0 ${rgba(theme.palettes.brand.primary, 0.15)};
  `, theme.palettes.neutrals.medium, $error && `
      border-color: ${theme.palettes.status.alert};
    `, theme.palettes.neutrals.lightest, theme.palettes.neutrals.lightest, theme.palettes.brand.primary);
};
export const text = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", " line-height:initial;flex-grow:1;text-align:center;"], getTypography(theme, TypographyName.BODY));
};
//# sourceMappingURL=CheckboxButton.style.js.map